import classNames from 'classnames'
import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

type CombinatorInGroupProps = {
  groupIndex: number
  ruleIndex?: number
  isInGroup?: true
}

type CombinatorProps = {
  groupIndex: number
  isInGroup?: false
}

type Props = CombinatorInGroupProps | CombinatorProps

const CombinatorSelector = (props: Props): React.ReactNode => {
  const { setValue } = useFormContext()
  const baseName = props.isInGroup
    ? `groups.${props.groupIndex}.rules.${props.ruleIndex}`
    : `groups.${props.groupIndex}`
  const combinator = useWatch({ name: `${baseName}` })
  const combinatorAndClassNames = classNames(
    'border-gainsboro-gray border-2 px-2 py-2 font-bold min-w-[50px] text-center',
    {
      'bg-gainsboro-gray': combinator.value === 'and',
      'cursor-pointer': props.isInGroup,
      'rounded-md': !props.isInGroup,
      'rounded-l-md': props.isInGroup,
    },
  )

  const combinatorOrClassNames = classNames(
    'border-gainsboro-gray border-2 rounded-r-md px-2 font-bold py-2 min-w-[50px] text-center',
    {
      'bg-gainsboro-gray': combinator.value === 'or',
      'cursor-pointer': props.isInGroup,
    },
  )

  return (
    <div className={`relative ${props.isInGroup ? 'ml-4' : 'ml-14'}`}>
      <div className={'rounded-md flex text-xs'}>
        <div
          onClick={() => {
            setValue(`${baseName}`, { type: 'combinator', label: 'AND', value: 'and' })
          }}
          className={combinatorAndClassNames}>
          And
        </div>
        {props.isInGroup && (
          <div
            onClick={() => {
              setValue(`${baseName}`, { type: 'combinator', label: 'OR', value: 'or' })
            }}
            className={combinatorOrClassNames}>
            Or
          </div>
        )}
      </div>
      <div className={'w-[2px] h-4 bg-gainsboro-gray absolute -top-4 left-6'} />
      <div className={'w-[2px] h-4 bg-gainsboro-gray absolute -bottom-4 left-6'} />
    </div>
  )
}
export default CombinatorSelector
